"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Snackbar_1 = require("./Snackbar");
const SnackbarContent_1 = require("../snackbarContent/SnackbarContent");
const { root } = Snackbar_1.snackbarClasses;
const { root: snackbarContentRoot, message: snackbarContentMessage, action: snackbarContentAction, } = SnackbarContent_1.snackbarContentClasses;
const MuiSnackbarOverrides = {
    MuiSnackbar: {
        defaultProps: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
            autoHideDuration: 4000,
            ContentProps: { elevation: 0 },
            ClickAwayListenerProps: {
                onClickAway: () => { },
            },
        },
        styleOverrides: {
            root: ({ theme, ownerState }) => ({
                [`&.${root}`]: {
                    backgroundColor: theme.palette.gray[900],
                    borderRadius: 4,
                    width: '320px',
                    height: '42px',
                    padding: '4px 16px',
                    [`.${snackbarContentRoot}`]: {
                        width: '100%',
                        borderRadius: 4,
                        padding: 0,
                        justifyContent: 'space-between',
                        backgroundColor: theme.palette.gray[900],
                        [`.${snackbarContentMessage}`]: {
                            fontSize: '0.875rem',
                            color: theme.palette.common.white,
                            padding: 0,
                            width: ownerState.action ? '194px' : '100%',
                            maxHeight: '48px',
                            minHeight: '21px',
                            overflow: 'auto',
                        },
                        [`.${snackbarContentAction}`]: {
                            marginLeft: 0,
                            paddingLeft: 0,
                        },
                    },
                },
            }),
        },
    },
};
exports.default = MuiSnackbarOverrides;
//# sourceMappingURL=MuiSnackbarOverrides.js.map